export default class UpdateImpossibleError extends Error {}
